import OperationsOwnerPerformanceReportPage from "../../shared/OperationsOwnerPerformanceReportPage";

const SolarentOperatorOperationsOwnerPerformanceReportPage = () => (
  <OperationsOwnerPerformanceReportPage operationsSource="SolarentOperator" />
);

export default SolarentOperatorOperationsOwnerPerformanceReportPage;
